<template>
  <div :data-ver="$root.content.version">
    <div class="wrapper__header">
      <!-- <simple-title
        class="header"
        :header="$root.content.header"
      /> -->
      <div class="wrapper__headerImage">
        <div
          class="headerImage__shadow"
          :style="{
            backgroundImage: `url(${allImages[$root.content.header.image.src].ImgthumbBlurLarge})`
          }"
        />
        <responsive-image
          :image="allImages[$root.content.header.image.src].Img600"
          :imageFiles="allImages[$root.content.header.image.src]"
          :alt="$root.content.header.image.alt"
          :style="{
            borderRadius: '8px',
            overflow: 'hidden',
          }"
        />
        <!-- <img
          class="headerImage"
          :src="allImages[$root.content.header.image.src].Img400"
          :alt="$root.content.header.image.alt"
        /> -->
      </div>
    </div>

    <!-- <p class="wrapper__social">
      <span
        v-for="(word, i) in socialMessage"
        :key="`social-${i}`"
        :class="{ hashtag: word.hashtag }"
      >
        {{ word.w }}
      </span>
    </p> -->


    <div class="wrapper__parts">
      <a
        :class="{
          wrapper__link: true,
          'wrapper__link--hover': hoveredLink === part.type
        }"
        v-for="(part, i) in $root.content.parts"
        :key="`part-${i}`"
        :href="part.link"
        :style="style__link"
        @mouseover="mouseoverLink(part.type)"
        @mouseout="mouseoutLink"
      >
        <div class="glow"></div>
        <p class="link__text link__text--title"><b>{{ part.title }}</b></p>
        <p v-if="part.subtitle" class="link__text link__text--subtitle"><i>{{ part.subtitle }}</i></p>
        <div class="icon__wrapper">
          <div :is="part.icon" fill="#efefef"></div>
        </div>
      </a>
    </div>
  </div>
</template>


<script>
import SimpleTitle from '@/components/headers/simple-title.vue'
import ResponsiveImage from '@/components/responsive-image.vue'

export default {
  name: 'link-block',
  props: [],
  components: {
    SimpleTitle,
    ResponsiveImage,
  },
  data () {
    return {
      allImages: this.$root.content.allImages,
      hoveredLink: null,
    }
  },
  methods: {
    mouseoverLink (val) {
      this.hoveredLink = val
    },
    mouseoutLink () {
      this.hoveredLink = null
    }
  },
  computed: {
    style__link () {
      const { allImages, header: {image: {src}} } = this.$root.content
      // console.log(`rgb(${allImages[src].colors.Vibrant._rgb.join(',')})`)
      const colors = {
        // from: `rgb(${allImages[src].colors.Vibrant._rgb.join()})`,
        from: `rgb(205, 207, 210)`,
        // to: `rgb(${allImages[src].colors.DarkVibrant._rgb.join()})`,
        to: `rgb(225, 227, 230)`,
      }
      return {
        background: `linear-gradient(45deg, ${colors.to}, ${colors.from})`
      }
    },
    socialMessage () {
      return this.$root.content.social
        .split(' ')
        .map(w =>  ({ w, hashtag: w.includes('#') }))
    },
  },
}
</script>


<style scoped lang="sass">
@import index

.wrapper
  &__header
    // border: solid 1px lime
    // display: flex
    // max-width: 400px
    margin: 0 auto 32px auto
    align-items: flex-start
  &__headerImage
    // position: relative
    // max-width: 150px
    // flex: 1 1 auto
    // img
      // transform-origin: center right
      // transform: scale(1.5) translate(0, -16px)
    .headerImage__shadow
      position: absolute
      left: 0
      top: 0
      width: 100%
      height: 100%
      // background-repeat: no-repeat
      transform: translate(0, 1%)
      filter: blur(10px)

  &__parts
    display: flex
    flex-wrap: wrap
  &__link
    flex-direction: column
    transition: all 200ms
    position: relative
    display: flex
    flex-wrap: wrap
    flex-direction: column
    justify-content: space-between
    align-items: center
    flex: 1 1 auto
    min-width: 130px
    width: 20%
    padding: 16px
    margin: 4px
    color: black
    text-decoration: none
    border-radius: 4px
    box-shadow: none
    &:visited
      border-color: none
    .glow
      transition: opacity 600ms
      position: absolute
      top: 0
      left: 0
      width: 100%
      height: 100%
      background: linear-gradient(45deg, rgba(#D8BD52, 0.8), rgba(white, 0.5))
      opacity: 0
    &--hover
      transform: translate(0, -8px)
      // text-shadow: 0 4px 6px rgba(black, 0.2)
      +shadow-box-2
      .glow
        opacity: 1
      svg
        transform: translate(-50%, -50%) scale(2) !important
    p.link__text
      width: 100%
      text-align: center
      color: black
      font-weight: 300
      font-size: 14px
      @media screen and (min-width: 500px)
        font-size: 16px
      line-height: 1.2
      text-decoration: none
      margin-bottom: 4px
      &:last-of-type
        margin-bottom: auto
      b
        color: rgba(black, 0.8)
        font-weight: 600
      i
        color: rgba(black, 0.8)
        font-weight: 300
        font-size: 14px
    .icon__wrapper
      width: 40px
      height: 40px
      background: rgba(black, 0.6)
      border-radius: 50px
      margin-top: 16px
      svg
        width: 20px
        height: 20px
        left: 50%
        top: 50%
        transform: translate(-50%, -50%) scale(1.8)
  &__social
    text-align: center
    margin-bottom: 16px !important
    display: block
    span
      display: inline-block
      vertical-align: top
      padding: 0 3px
      font-size: 24px
    .hashtag
      font-weight: 800
      // color: #41b58e
      color: #D8BD52


</style>



// WEBPACK FOOTER //
// src/layouts/link-block.vue